import { apiRequest } from '../lib/apiClient';

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const CATEGORY_LABELS = {
  basics: 'Basics',
  forms: 'Forms',
  grab_arts: 'Grab Arts',
  punch_attacks: 'Punch Attacks',
  self_defense: 'Self Defense',
  sparring: 'Sparring',
  street: 'Street',
  multiples: 'Multiples',
  weapons: 'Weapons',
  rolling: 'Rolling',
  sticky_hands: 'Sticky Hands',
  other: 'Other',
};

export const getActivities = (token) =>
  apiRequest(
    '/training-sessions/activities',
    { headers: authHeaders(token) },
    'Failed to load activities.'
  );

export const formatActivityCategory = (category) => {
  if (!category) return '';
  return CATEGORY_LABELS[category] || category;
};

export const createActivityNameMap = (activities = []) =>
  activities.reduce((acc, activity) => {
    acc[activity.id] = activity.name;
    return acc;
  }, {});

export const getActivityName = (activityNamesById, activityId) =>
  activityNamesById?.[activityId] || `Activity #${activityId}`;
